module.exports = __webpack_public_path__ + "static/media/referrals-lg.2a3d99eb.png";